/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ device: NonNullable<unknown> }} Plan_Linked_DeviceInputs */

const en_plan_linked_device = /** @type {(inputs: Plan_Linked_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You linked your payment via your ${i?.device}.`)
};

const es_plan_linked_device = /** @type {(inputs: Plan_Linked_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vinculaste tu pago a través de tu ${i?.device}.`)
};

/**
* | output |
* | --- |
* | "You linked your payment via your {device}." |
*
* @param {Plan_Linked_DeviceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_linked_device = /** @type {((inputs: Plan_Linked_DeviceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Linked_DeviceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_linked_device(inputs)
	return en_plan_linked_device(inputs)
});